import { Button } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { ArrowReload } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { UncaughtErrorProps } from "./UncaughtError.types";

export const UncaughtError: FC<UncaughtErrorProps> = ({ isChunkError }) => {
  const { t } = useCustomTranslation("common");

  return isChunkError ? (
    <ErrorTemplate
      data-testid="ChunkError-container"
      text=""
      title={t("errors.chunk.title")}
    >
      <Button onClick={() => window.location.reload()} startIcon={ArrowReload}>
        {t("errors.chunk.button")}
      </Button>
    </ErrorTemplate>
  ) : (
    <ErrorTemplate
      data-testid="UncaughtError-container"
      text=""
      title={t("errors.title.large")}
    >
      <Button onClick={() => window.location.reload()} startIcon={ArrowReload}>
        {t("errors.uncaught.button")}
      </Button>
    </ErrorTemplate>
  );
};
